import { rem } from "@certn/cascadia";
import {
  BrandAsset,
  Link,
  ModalTrigger,
  Text,
  useColors,
} from "@certn/cascadia-react";
import { getPrivacyPolicyUrl, getTermsOfUseUrl } from "@certn/utils";
import { css } from "@emotion/css";
import { Trans } from "react-i18next";
import { useLocation } from "react-router-dom";

import { LanguageModal } from "./LanguageModal";
import { useLanguage } from "../../hooks/useLanguage";

export function AppFooter() {
  const { currentLanguageLabel } = useLanguage();
  const location = useLocation();
  const showLanguageSelector =
    location.pathname !== "/auth" && location.pathname !== "/auth/welcome";
  const colors = useColors();
  const privacyPolicyUrl = getPrivacyPolicyUrl(currentLanguageLabel);
  const termsOfUseUrl = getTermsOfUseUrl(currentLanguageLabel);

  return (
    <>
      <div
        className={css({
          display: "flex",
          gap: rem("space-4"),
        })}
      >
        {showLanguageSelector && (
          <ModalTrigger
            trigger={() => (
              <Link
                linkStyle="monochrome"
                testID="footer-language-link"
                textColor="text-weak"
                textStyle="global/body-secondary"
                leftIcon="language"
              >
                {currentLanguageLabel}
              </Link>
            )}
          >
            {(close) => <LanguageModal onClose={close} />}
          </ModalTrigger>
        )}
        <Link
          textColor="text-weak"
          textStyle="global/body-secondary"
          linkStyle="monochrome"
          href={privacyPolicyUrl}
          testID="footer-privacy-policy-link"
          target="_blank"
        >
          <Trans>Privacy policy</Trans>
        </Link>
        <Link
          linkStyle="monochrome"
          textColor="text-weak"
          textStyle="global/body-secondary"
          href={termsOfUseUrl}
          testID="footer-terms-of-use-link"
          target="_blank"
        >
          <Trans>Terms of use</Trans>
        </Link>
      </div>
      <Text color="text-weak" testID="footer-powered-by-link">
        <Trans>
          Powered by{" "}
          <BrandAsset
            height="18"
            width="62"
            type="full"
            brand="certn"
            fill={colors["icon-base"]}
            className={css({ verticalAlign: "middle" })}
          />
        </Trans>
      </Text>
    </>
  );
}
